import { genres } from "@/mocks/movieData";
import SectionHeading, { Section } from "./SectionHeading";

export default function GenreTypes() {
  return (
    <Section id="genres" className="bg-background-100">
      <SectionHeading
        eyebrow="内容类型"
        accent="accent"
        title="站内常见的内容类型与观看节奏"
        description="不同类型的观看方式和时间安排差别很大。先了解每一类的大致形态，再决定今天想花多长时间。"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {genres.map((genre, index) => (
          <article
            key={genre.id}
            className={`rounded-lg bg-background-50 border border-background-200 p-4 md:p-5 ${
              index === 0 ? "sm:col-span-2 lg:col-span-1" : ""
            }`}
          >
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-900">
                <i className={`${genre.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{genre.name}</h3>
            </div>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{genre.desc}</p>
            <p className="mt-3 inline-flex items-center gap-1.5 text-xs font-label text-secondary-900 bg-secondary-100 px-2.5 py-1 rounded-full">
              <i className="ri-time-line" aria-hidden="true"></i>
              {genre.highlight}
            </p>
          </article>
        ))}

        <article className="rounded-lg bg-primary-500 text-background-50 p-4 md:p-5 flex flex-col justify-between">
          <div>
            <h3 className="font-heading text-lg font-bold">不知道怎么选？</h3>
            <p className="mt-2 text-sm leading-relaxed opacity-95">
              如果你只是想随便看看，可以先从「片单速览」里按类型浏览，挑选一部时长合适的电影，比纠结类型更快。
            </p>
          </div>
          <a
            href="#titles"
            className="mt-5 inline-flex items-center gap-1 text-sm font-label text-background-50 hover:underline whitespace-nowrap"
          >
            去片单速览
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </article>
      </div>
    </Section>
  );
}